import React, { useState, useEffect } from 'react';
import { string, oneOfType, element, bool, arrayOf, node, func, object } from 'prop-types';
import { ArrowBack } from '@magalu/stereo-ui-icons';
import Sidebar from '../Sidebar';
import Accordion from '../../atoms/Accordion';
import { Header, Centered, Title } from './action-detail.styles';

function ActionDetail({
  label,
  content,
  detailTitle,
  fullScreen,
  children,
  open,
  onCloseSidebar,
  onChangeOpen
}) {
  const [showDetail, setShowDetail] = useState(open);
  useEffect(() => {
    setShowDetail(open);
    onChangeOpen(open);
  }, [open]);

  function handleClickOutside() {
    setShowDetail(false);
    onChangeOpen(false);
    onCloseSidebar();
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    title: label,
    open: !!content,
    onClick: () => {
      setShowDetail(!showDetail);
      onChangeOpen(!showDetail);
    }
  }, content), /*#__PURE__*/React.createElement(Sidebar, {
    direction: "right",
    visible: showDetail,
    onClickOutside: handleClickOutside,
    fullScreen: fullScreen
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(ArrowBack, {
    color: "text.light",
    "data-testid": "arrow-back",
    role: "button",
    title: "Fechar detalhes",
    onClick: handleClickOutside
  }), /*#__PURE__*/React.createElement(Centered, null, /*#__PURE__*/React.createElement(Title, {
    "data-testid": "detail-title"
  }, detailTitle))), children));
}

ActionDetail.defaultProps = {
  content: null,
  open: false,
  onCloseSidebar: () => {},
  onChangeOpen: () => {}
};
process.env.NODE_ENV !== "production" ? ActionDetail.propTypes = {
  label: string,
  detailTitle: string,
  fullScreen: bool,
  content: oneOfType([element, string, object, arrayOf(element), node]),
  children: oneOfType([element, string, object, arrayOf(element), node]),
  open: bool,
  onCloseSidebar: func,
  onChangeOpen: func
} : void 0;
export default ActionDetail;